module.exports = __webpack_public_path__ + "media/images/icons/cm-contact-form/email-882a9123f193362b49e1bc4a5a6d3b54.svg";